<div>
  <div class="head-section">
    <h6 class="header-text text-white">
      EDIT {{ userDetail?.displayname | uppercase }}
    </h6>
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      (click)="close()"
    >
      <g clip-path="url(#clip0_3558_32756)">
        <path
          d="M1.96338 16.9345L9.47846 9.41938M16.9935 1.9043L9.47703 9.41938M9.47703 9.41938L1.96338 1.9043M9.47846 9.41938L16.9935 16.9345"
          stroke="#F00000"
          stroke-width="2.16781"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3558_32756">
          <rect
            width="17.3425"
            height="17.3425"
            fill="white"
            transform="translate(0.806641 0.748047)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
  <div class="body-section">
    <form
      *ngIf="
        userDetail?.taxgroup == 'COMPANY' || userDetail?.taxgroup == 'INFORMAL'
      "
      class="cust-width m-3"
      [formGroup]="editCompanyForm"
    >
      <div class="row personal-form">
        <div class="col-md-4">
          <div class="form-group mb-2">
            <label>Company Name <span class="text-danger">*</span></label>
            <input
              formControlName="corporateName"
              type="text"
              class="form-control"
              placeholder="Company Name"
            />
            <div
              *ngIf="
                editCompanyForm.get('corporateName')?.hasError('required') &&
                editCompanyForm.get('corporateName')?.touched
              "
            >
              <small class="text-danger">Company Name is required.</small>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group mb-2">
                <label>Address <span class="text-danger">*</span></label>
                <input
                  formControlName="address"
                  type="text"
                  class="form-control"
                  placeholder="5, xxxxx, Estate..."
                />
                <div
                  *ngIf="
                    editCompanyForm.get('address')?.hasError('required') &&
                    editCompanyForm.get('address')?.touched
                  "
                >
                  <small class="text-danger">Address is required.</small>
                </div>
              </div>
              <div class="form-group mb-2">
                <label>Nature of Business</label>
                <select class="form-control" formControlName="natureOfBusiness">
                  <option value="">Select option</option>
                  <option
                    *ngFor="let natureOfBusiness of natureOfBusinessList"
                    [value]="natureOfBusiness?.name"
                  >
                    {{ natureOfBusiness?.name }}
                  </option>
                </select>

                <!-- <select class="form-control" formControlName="natureOfBusiness">
                  <option default>
                    {{ companyDetails?.natureOfBusiness }}
                  </option>
                  <option
                    value="ACTIVITIES OF EXTRATERRITORIAL ORGANISATION AND BODIES"
                  >
                    Activities of Extraterritorial Organisations and Bodies
                  </option>
                  <option
                    value="ACTIVITIES OF HOUSE AS EMPLOYMENT UNDIFFERENTIATED GOODS-AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE"
                  >
                    Activities of Households as Employers; Undifferentiated
                    Goods- and Services-Producing Activities of Households for
                    Own Use
                  </option>
                  <option value="ACCOMODATION AND FOOD SERVICES ACTIVITIES">
                    Accommodation and Food Services Activities
                  </option>
                  <option value="ART, ENTERTAINMENT AND RECREATION">
                    Art, Entertainment and Recreation
                  </option>
                  <option value="COMMUNITY BASED ASSOCIATION">
                    Community-Based Association
                  </option>
                  <option value="CONSTRUCTION">Construction</option>
                  <option value="CULTURAL BASED ASSOCIATION">
                    Cultural-Based Association
                  </option>
                  <option value="EDUCATION">Education</option>
                  <option value="FAITH BASED ASSOCIATION">
                    Faith-Based Association
                  </option>
                  <option value="FINANCIAL AND INSURANCE ACTIVITIES">
                    Financial and Insurance Activities
                  </option>
                  <option value="FOUNDATION BASED ASSOCIATION">
                    Foundation-Based Association
                  </option>
                  <option value="HUMAN HEALTH AND SOCIAL WORK ACTIVITIES">
                    Human Health and Social Work Activities
                  </option>
                  <option value="INFORMATION AND COMMUNICATION">
                    Information and Communication
                  </option>
                  <option value="MANUFACTURING">Manufacturing</option>
                  <option value="MINING AND QUARRYING">
                    Mining and Quarrying
                  </option>
                  <option
                    value="OTHER ACTIVITIES OF EXTRA-TERRITORIAL ORGANIZATION AND BODIES"
                  >
                    Other Activities of Extraterritorial Organisations and
                    Bodies
                  </option>
                  <option value="OTHER SERVICE ACTIVITIES">
                    Other Service Activities
                  </option>
                  <option value="POWER">Power</option>
                  <option
                    value="PROFESSIONAL,SCIENTIFIC AND TECHNICAL ACTIVITIES"
                  >
                    Professional, Scientific and Technical Activities
                  </option>
                  <option
                    value="PUBLIC ADMINISTRATION AND DEFENCE;DEFENCE, COMPULSORY SOCIAL SECURITY"
                  >
                    Public Administration and Defence; Defence, Compulsory
                    Social Security
                  </option>
                  <option value="REPAIRS OF MOTORVEHICLES AND MOTORCYCLES">
                    Repairs of Motor Vehicles and Motorcycles
                  </option>
                  <option value="REAL ESTATE ACTIVITIES">
                    Real Estate Activities
                  </option>
                  <option value="SOCIAL CLUBS BASED ASSOCIATION">
                    Social Clubs-Based Association
                  </option>
                  <option value="SPORTING BASED ASSOCIATION">
                    Sporting-Based Association
                  </option>
                  <option value="TRANSPORTATION">Transportation</option>
                  <option
                    value="WATERSUPPLY,SEWERAGE,WASTEMANAGEMENT AND REMEDIATION ACTIVITIES"
                  >
                    Watersupply, Sewerage, Waste Management and Remediation
                    Activities
                  </option>
                  <option
                    value="WHOLESALE AND RETAIL TRADE;REPAIR OF MOTOR VEHICLES AND MOTOR VEHICLES AND MOTORCYCLES"
                  >
                    Wholesale and Retail Trade; Repair of Motor Vehicles and
                    Motorcycles
                  </option>
                </select> -->
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="col-md-12">
            <div class="form-group mb-2">
              <label>Email <span class="text-danger">*</span></label>
              <input
                formControlName="email"
                type="email"
                class="form-control readonly-input"
                placeholder="axxxxx@gmail.com"
                readonly
              />
            </div>
          </div>

          <div class="form-group mb-2">
            <label>RC. Number</label>
            <input
              formControlName="rcNumber"
              type="text"
              class="form-control"
              placeholder="32xxxxx"
            />
          </div>

          <div class="form-group mb-2">
            <label>Classification</label>
            <select class="form-control" formControlName="classification">
              <option value="">Select option</option>
              <option
                *ngFor="let classification of businessClassificationList"
                [value]="classification?.name"
              >
                {{ classification?.name }}
              </option>
              <!-- <option default>{{ companyDetails?.classification }}</option>
              <option value="BUSINESS_NAME">Business Name</option>
              <option value="COMPANY">Company</option>
              <option value="INCORPORATED_TRUSTEE">Incorporated Trustee</option>
              <option value="LIMITED_PARTNERSHIP">Limited Partnership</option>
              <option value="LIMITED_LIABILITY_PARTNERSHIP">
                Limited Liability Partnership
              </option> -->
            </select>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group mb-2">
            <label>Mobile Number <span class="text-danger">*</span></label>
            <input
              formControlName="phoneNumber"
              type="text"
              class="form-control"
              placeholder="Mobile Number"
            />
            <div
              *ngIf="editCompanyForm.get('phoneNumber')?.hasError('required')"
            >
              <small class="text-danger">Mobile Number is required</small>
            </div>
            <div
              *ngIf="
                editCompanyForm
                  .get('phoneNumber')
                  ?.hasError('invalidPhoneNumber')
              "
            >
              <small class="text-danger">Invalid phone number format</small>
            </div>
          </div>
          <div class="form-group mb-2">
            <label>LGA</label>
            <select class="form-control" formControlName="lgaId">
              <option value="">
                {{ companyDetails?.lgaName | uppercase }}
              </option>
              <option [value]="lga?.id" *ngFor="let lga of lgaList">
                {{ lga?.name }}
              </option>
            </select>
          </div>
          <div class="form-group mb-2">
            <label>TIN <span class="text-danger">*</span></label>
            <input
              formControlName="tin"
              type="text"
              class="form-control readonly-input"
              placeholder="32xxxxxxxxxxx"
              readonly
            />
          </div>
        </div>
      </div>
    </form>

    <!-- non company starts here -->
    <form
      class="cust-width m-3"
      *ngIf="
        userDetail?.taxgroup != 'COMPANY' && userDetail?.taxgroup != 'INFORMAL'
      "
      [formGroup]="editNonCompanyForm"
    >
      <div class="row personal-form">
        <div class="col-md-4">
          <div class="form-group mb-2">
            <label>First Name <span class="text-danger">*</span></label>
            <input
              formControlName="firstName"
              type="text"
              class="form-control"
              placeholder="First Name"
            />
            <div
              *ngIf="
                editNonCompanyForm.get('firstName')?.hasError('required') &&
                editNonCompanyForm.get('firstName')?.touched
              "
            >
              <small class="text-danger">First name is required.</small>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group mb-2">
                <label>Gender</label>
                <select class="form-control" formControlName="gender">
                  <option default>{{ userDetails?.gender | uppercase }}</option>
                  <option value="MALE">Male</option>
                  <option value="FEMALE">Female</option>
                </select>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group mb-2">
                <label>Date of Birth</label>
                <input
                  formControlName="dob"
                  type="date"
                  class="form-control readonly-input"
                  readonly
                />
              </div>
            </div>
          </div>
          <div class="form-group mb-2">
            <label>LGA</label>
            <select class="form-control" formControlName="lgaId">
              <option value="">{{ userDetails?.lgaName | uppercase }}</option>
              <option [value]="lga?.id" *ngFor="let lga of lgaList">
                {{ lga?.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group mb-2">
            <label>Last Name <span class="text-danger">*</span></label>
            <input
              formControlName="lastName"
              type="text"
              class="form-control"
              placeholder="Last name"
            />
            <div
              *ngIf="
                editNonCompanyForm.get('lastName')?.hasError('required') &&
                editNonCompanyForm.get('lastName')?.touched
              "
            >
              <small class="text-danger">Last Name is required.</small>
            </div>
          </div>
          <div class="form-group mb-2">
            <label>Mobile Number <span class="text-danger">*</span></label>
            <input
              formControlName="phoneNumber"
              type="text"
              class="form-control"
              placeholder="Mobile Number"
            />
            <div
              *ngIf="
                editNonCompanyForm.get('phoneNumber')?.hasError('required')
              "
            >
              <small class="text-danger">Mobile Number is required</small>
            </div>
            <div
              *ngIf="
                editNonCompanyForm
                  .get('phoneNumber')
                  ?.hasError('invalidPhoneNumber')
              "
            >
              <small class="text-danger">Invalid phone number format</small>
            </div>
          </div>
          <div class="form-group mb-2">
            <label>NIN</label>
            <input
              formControlName="nin"
              type="text"
              class="form-control"
              placeholder="32xxxxxxxxxxx"
            />
            <div
              *ngIf="
                editNonCompanyForm.get('nin')?.hasError('required') &&
                editNonCompanyForm.get('nin')?.touched
              "
            >
              <small class="text-danger"> NIN is required.</small>
            </div>
          </div>
          <div class="form-group mb-2">
            <label>Occupation</label>
            <select class="form-control" formControlName="occupationId">
              <option value="">
                {{ userDetails?.occupation | uppercase }}
              </option>
              <option
                [value]="occupation?.id"
                *ngFor="let occupation of occupationList"
              >
                {{ occupation?.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group mb-2">
            <label>Tax Payer’s ASIN <span class="text-danger">*</span></label>
            <input
              formControlName="tin"
              type="text"
              class="form-control readonly-input"
              placeholder="32xxxxxxxxxxx"
              readonly
            />
          </div>
          <div class="form-group mb-2">
            <label>Email Address <span class="text-danger">*</span></label>
            <input
              formControlName="email"
              type="email"
              class="form-control readonly-input"
              placeholder="axxxxx@gmail.com"
              readonly
            />
          </div>
          <div class="form-group mb-2">
            <label>Marital Status</label>
            <select class="form-control" formControlName="maritalStatus">
              <option default>{{ userDetails?.maritalStatus }}</option>
              <option value="DIVORCED">Divorced</option>
              <option value="MARRIED">Married</option>
              <option value="SINGLE">Single</option>
              <option value="WIDOWED">Widowed</option>
            </select>
          </div>
          <div class="form-group mb-2">
            <label
              >Residential Address <span class="text-danger">*</span></label
            >
            <input
              formControlName="address"
              type="text"
              class="form-control"
              placeholder="5, xxxxx, Estate..."
            />
            <div
              *ngIf="
                editNonCompanyForm.get('address')?.hasError('required') &&
                editNonCompanyForm.get('address')?.touched
              "
            >
              <small class="text-danger">Address is required.</small>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="modal-footer">
      <div class="top-border other-width d-flex justify-content-end">
        <button
          *ngIf="
            userDetail?.taxgroup != 'COMPANY' &&
            userDetail?.taxgroup != 'INFORMAL'
          "
          type="submit"
          class="btn btn-sm btn-outline-dark custom-button-style"
          [disabled]="!editNonCompanyForm.valid"
          (click)="confirmEdit()"
        >
          Update Information
        </button>
        <button
          *ngIf="
            userDetail?.taxgroup == 'COMPANY' ||
            userDetail?.taxgroup == 'INFORMAL'
          "
          type="submit"
          class="btn btn-sm btn-outline-dark custom-button-style"
          [disabled]="!editCompanyForm.valid"
          (click)="confirmCompanyEdit()"
        >
          Update Information
        </button>
      </div>
    </div>
  </div>
</div>
